import { useReduxState } from 'hooks';
import api from 'api';
import { ConfirmButton } from 'components/common';

import type { GetFeedbacksRes } from 'shared-types/responses';

interface Props {
  feedback: GetFeedbacksRes['feedbacks'][0];
  updateFeedbacks: () => Promise<void>;
}

const FeedbackDelete = ({ feedback, updateFeedbacks }: Props) => {
  const { messages } = useReduxState();

  const deleteFeedback = async () => {
    const response = await api.delete(
      `/admin/courses/${feedback.courseId}/feedbacks/${feedback.id}`
    );
    if (!response.data || !response.data.success) return false;
    await updateFeedbacks();
    return true;
  };

  return (
    <ConfirmButton
      actionText={messages.commonDelete}
      buttonIcon="trash-alt"
      buttonText={messages.commonDelete}
      category="danger"
      confirmText={messages.feedbackDeleteFeedbackConfirm}
      confirmTitle={messages.feedbackDeleteFeedback}
      onConfirm={deleteFeedback}
      successMessage={messages.feedbackDeleteFeedbackSuccess}
    />
  );
};

export default FeedbackDelete;
